type PdfJsModule = typeof import('pdfjs-dist')

const PDF_JS_URL = 'https://unpkg.com/pdfjs-dist@5.4.149/build/pdf.min.mjs'
const PDF_WORKER_URL =
  'https://unpkg.com/pdfjs-dist@5.4.149/build/pdf.worker.min.mjs'

let pdfJsModulePromise: Promise<PdfJsModule> | null = null

/**
 * Loads PDF.js as a native browser module. Next.js cannot safely wrap the
 * pre-bundled PDF.js ESM build in its own Webpack runtime.
 */
export const loadPdfJs = (): Promise<PdfJsModule> => {
  pdfJsModulePromise ??= import(/* webpackIgnore: true */ PDF_JS_URL).then(
    (pdfjsModule) => {
      const pdfjs = pdfjsModule as PdfJsModule
      pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_URL
      return pdfjs
    }
  )

  return pdfJsModulePromise
}
